// @vendors
const React = require("react");
const PropTypes = require("prop-types");

//@components
const {
    SignaturePattern,
} = require("components/signaturePattern/signaturePattern");
const { OKButton } = require("components/commons/OKButton/OKButton");

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_TYPE,
    BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_PARAMS
} = require('constants/index');

//@utilities
const { FormattedText } = require("core/i18n").i18n;
class BrokerOtpConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    finish() {
        this.props.onTestResultsConfirm();
    }

    render() {
        const { immBrokerConvenienceMiFIDTest } =
            this.props;

        const loading = immBrokerConvenienceMiFIDTest.get('loading')

        return (
            <React.Fragment>
                <SignaturePattern
                    operationType={BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_TYPE}
                    operationParams={BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_PARAMS}
                />
                <div className="ra-suitability-test-success__button">
                    <OKButton onClick={() => this.finish()} disabled={loading} loading={loading}>
                        <FormattedText value="raSuitabilityTestSuccess-ctaButton" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }
}

BrokerOtpConfirmation.propTypes = {
    onTestResultsConfirm: PropTypes.func,
};

module.exports = BrokerOtpConfirmation;
